<template>
  <div
    class="compreSportsMeet_mergeHeadCel_table"
    :class="[
      tableMode,
      themeClass,
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : '',
    ]"
    v-if="currThemeObj.cssStyle && tableData"
  >
    <el-table
      :data="tableData"
      style="width: 100%"
      header-row-class-name="mixtmt_table_header"
      :summary-method="getSummaries"
      :cell-style="cellStyle"
      :row-class-name="rowClassName"
      :header-cell-style="headerCellStyle"
      :show-summary="isSummaryFlag"
    >
      <el-table-column
        v-for="group in tableColumnData"
        :key="group.key"
        :label="group.label"
        :prop="group.child ? '' : group.prop"
        :width="!group.child && group.widthPx ? group.widthPx : ''"
        :class-name="group.className ? group.className : ''"
      >
        <template slot-scope="scope">
          <!-- ['teamLogo-teamName'] tableMode = "eventComp_mode_17 || eventComp_mode_21" -->
          <template v-if="group.prop == 'teamLogo-teamName'">
            <template v-if="tableMode === 'eventComp_mode_21_SHO'">
              <span
                v-if="scope.row['isRowMark'] === 'showTeam'"
                :class="group.prop"
              >
                <span
                  class="teamLogo"
                  :class="scope.row['team_logo'] ? 'isLogo' : ''"
                >
                  <img
                    v-if="scope.row['team_logo']"
                    :src="scope.row['team_logo']"
                  />
                </span>
                <span
                  class="teamName"
                  v-text="_valPerFormatHandler(scope.row['team_name'])"
                  @click="goDetail('CSMeetDelegationDetailIndex', scope.row)"
                ></span>
              </span>
            </template>
            <template v-else>
              <span :class="group.prop" @click="goDetail('', scope.row)">
                <span
                  class="teamLogo"
                  :class="scope.row['team_logo'] ? 'isLogo' : ''"
                >
                  <img
                    v-if="scope.row['team_logo']"
                    :src="scope.row['team_logo']"
                  />
                </span>
                <span
                  class="teamName"
                  v-text="_valPerFormatHandler(scope.row['team_name'])"
                  @click="goDetail('CSMeetDelegationDetailIndex', scope.row)"
                ></span>
              </span>
            </template>
          </template>

          <!--['playerName-playerLogo-playerGender-teamLogo-teamName'] tableMode = "eventComp_mode_17 || eventComp_mode_21" -->
          <template
            v-else-if="
              group.prop ==
              'playerName-playerLogo-playerGender-teamLogo-teamName'
            "
          >
            <template v-if="tableMode === 'eventComp_mode_21_SHO'">
              <span
                v-if="scope.row['isRowMark'] === 'showPlayer'"
                :class="group.prop"
              >
                <span
                  class="playerLogo"
                  :class="[
                    scope.row['player_logo'] ? 'isLogo' : '',
                    scope.row['player_gender'],
                  ]"
                >
                  <img
                    v-if="scope.row['player_logo']"
                    :src="scope.row['player_logo']"
                  />
                </span>
                <span class="playerOther">
                  <span class="teamInfor">
                    <span
                      class="teamLogo"
                      :class="scope.row['team_logo'] ? 'isLogo' : ''"
                    >
                      <img
                        v-if="scope.row['team_logo']"
                        :src="scope.row['team_logo']"
                      />
                    </span>
                    <span
                      class="teamName"
                      v-text="_valPerFormatHandler(scope.row['team_name'])"
                    ></span>
                  </span>
                  <span
                    class="playerName"
                    v-text="_valPerFormatHandler(scope.row['player_name'])"
                    @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
                  ></span>
                </span>
              </span>
            </template>
            <template v-else>
              <span :class="group.prop">
                <span
                  class="playerLogo"
                  :class="[
                    scope.row['player_logo'] ? 'isLogo' : '',
                    scope.row['player_gender'],
                  ]"
                >
                  <img
                    v-if="scope.row['player_logo']"
                    :src="scope.row['player_logo']"
                  />
                </span>
                <span class="playerOther">
                  <span class="teamInfor">
                    <span
                      class="teamLogo"
                      :class="scope.row['team_logo'] ? 'isLogo' : ''"
                    >
                      <img
                        v-if="scope.row['team_logo']"
                        :src="scope.row['team_logo']"
                      />
                    </span>
                    <span
                      class="teamName"
                      v-text="_valPerFormatHandler(scope.row['team_name'])"
                    ></span>
                  </span>
                  <span
                    class="playerName"
                    v-text="_valPerFormatHandler(scope.row['player_name'])"
                    @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
                  ></span>
                </span>
              </span>
            </template>
          </template>

          <!--['single_player_name'] tableMode = "eventComp_mode_5" -->
          <span
            v-else-if="group.prop === 'single-player-name'"
            :class="group.prop"
          >
            <span
              class="playerName"
              v-text="_valPerFormatHandler(scope.row['player_name'])"
              @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
            ></span>
          </span>

          <!-- tableMode = "eventComp_mode_17" -->
          <span v-else-if="group.prop.indexOf('_color') > -1" class="color">
            <span
              class="colorArea"
              :style="{
                backgroundColor: `${scope.row[group.prop]}`,
                borderColor: `${
                  ['WHITE', 'white'].includes(scope.row[group.prop])
                    ? 'GREY'
                    : scope.row[group.prop]
                }`,
              }"
            ></span>
          </span>

          <!-- 姿势 ['pose'] tableMode = "eventComp_mode_17_SHO" -->
          <span
            v-else-if="
              tableMode === 'eventComp_mode_17_SHO' &&
              group.prop === 'pose' &&
              scope.row.row_detail &&
              scope.row.row_detail.length > 0
            "
            class="group_rowCeilClass"
          >
            <span
              class="rowCeilClass"
              v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
              :key="rowCeilIndex"
              v-text="rowCeil[group.prop]"
            ></span>
          </span>

          <!-- 小计 ['cumulative_score'] tableMode = "eventComp_mode_17_SHO" -->
          <span
            v-else-if="
              tableMode === 'eventComp_mode_17_SHO' &&
              group.prop === 'cumulative_score' &&
              scope.row.row_detail &&
              scope.row.row_detail.length > 0
            "
          >
            <span
              class="rowCeilClass"
              v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
              :key="rowCeilIndex"
              v-text="rowCeil[group.prop]"
            ></span>
          </span>

          <!-- 跪姿 ['kneeling'] tableMode = "eventComp_mode_17_SHO" -->
          <span
            v-else-if="
              tableMode === 'eventComp_mode_17_SHO' &&
              group.prop === 'kneeling' &&
              scope.row.row_detail &&
              scope.row.row_detail.length > 0
            "
            class="group_rowCeilClass"
          >
            <span
              class="rowCeilClass"
              v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
              :key="rowCeilIndex"
              v-text="rowCeil[group.prop]"
            ></span>
          </span>

          <!-- 卧姿 ['prone'] tableMode = "eventComp_mode_17_SHO" -->
          <span
            v-else-if="
              tableMode === 'eventComp_mode_17_SHO' &&
              group.prop === 'prone' &&
              scope.row.row_detail &&
              scope.row.row_detail.length > 0
            "
            class="group_rowCeilClass"
          >
            <span
              class="rowCeilClass"
              v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
              :key="rowCeilIndex"
              v-text="rowCeil[group.prop]"
            ></span>
          </span>

          <!-- 阶段 ['stage'] tableMode = "eventComp_mode_17_SHO" -->
          <span
            v-else-if="
              tableMode === 'eventComp_mode_17_SHO' &&
              group.prop === 'stage' &&
              scope.row.row_detail &&
              scope.row.row_detail.length > 0
            "
            class="group_rowCeilClass"
          >
            <span
              class="rowCeilClass"
              v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
              :key="rowCeilIndex"
              v-text="rowCeil[group.prop]"
            ></span>
          </span>

          <span v-else v-text="scope.row[scope.column.property]"></span>
        </template>
        <el-table-column
          v-for="item in group.child"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.widthPx ? item.widthPx : ''"
          :class-name="item.className ? item.className : ''"
        >
          <template slot-scope="scope">
            <span
              v-if="
                tableMode === 'eventComp_mode_17_SHO' &&
                (columnColorPropArr.includes(item.prop) ||
                  columnColorPropArr_otherBg.includes(item.prop)) &&
                scope.row.row_detail &&
                scope.row.row_detail.length > 0
              "
              class="group_rowCeilClass"
            >
              <span
                class="rowCeilClass"
                v-for="(rowCeil, rowCeilIndex) in scope.row.row_detail"
                :key="rowCeilIndex"
                v-text="rowCeil[item.prop]"
              ></span>
            </span>
            <span v-else v-text="scope.row[item.prop]"></span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'mergeHeadCel_tablel',
  mixins: [cup_base_data_mixin],
  props: {
    tableMode: {
      type: String,
      default: '', //类型
    },
    isSummaryFlag: {
      //是否显示最后一行 总计
      type: Boolean,
      default: false,
    },
    columnColorPropArr: {
      //默认灰色背景
      type: Array,
      default: () => {
        return []
        // return [
        //   'stringAddition_Field_Goals_ma',
        //   'averageValue_Field_Goals_rate',
        // ]
      },
    },
    columnColorPropArr_otherBg: {
      //默认白色背景
      type: Array,
      default: () => {
        return []
        // return [
        //   'stringAddition_Field_Goals_ma',
        //   'averageValue_Field_Goals_rate',
        // ]
      },
    },
    textAlignleftPropArr: {
      type: Array,
      default: () => {
        return []
        // return ['player_name']
      },
    },
    tableColumnData: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     prop: 'bib_number',
        //     id: 'bib_number',
        //     label: 'No.',
        //     widthVw: 25.42, //对应列的宽度，单位vw
        //     className: 'columnNumLogoNameClass', //单独定制的头部样式class
        //     fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        //   },
        //   {
        //     prop: 'player_name',
        //     id: 'player_name',
        //     label: '运动员',
        //     widthVw: 25.42, //对应列的宽度，单位vw
        //     className: 'columnNumLogoNameClass', //单独定制的头部样式class
        //     fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        //   },
        //   {
        //     prop: '',
        //     id: 'FieldGoals',
        //     label: 'Field Goals',
        //     widthVw: 5.55,
        //     child: [
        //       {
        //         prop: 'stringAddition_Field_Goals_ma',
        //         label: 'M/A',
        //         widthVw: 5.55,
        //       },
        //       {
        //         prop: 'averageValue_Field_Goals_rate',
        //         label: '%',
        //         widthVw: 5.55,
        //       },
        //     ],
        //   },
        //   {
        //     prop: '',
        //     id: 'towPoints',
        //     label: '2 Points',
        //     widthVw: 5.55,
        //     child: [
        //       {
        //         prop: 'stringAddition_2_Point_ma',
        //         label: 'M/A',
        //         widthVw: 5.55,
        //       },
        //       {
        //         prop: 'averageValue_2_Point_rate',
        //         label: '%',
        //         widthVw: 5.55,
        //       },
        //     ],
        //   },
        // ]
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return []
      },
    },
    themeClass: {
      type: String,
      default: '', // onlyDisplay
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  data() {
    return {
      // tableData: [
      //   {
      //     pts: 7,
      //     tot: 0,
      //     or: 0,
      //     dr: 0,
      //     as: 0,
      //     to: 0,
      //     st: 0,
      //     bs: 0,
      //     pf: 0,
      //     fd: 0,
      //     organisation_code: 'KUW',
      //     player_id: 'BKBMS000143',
      //     bib_number: '2',
      //     player_name: 'ZHANG Min',
      //     stringAddition_Field_Goals_ma: '2/2',
      //     averageValue_Field_Goals_rate: 100,
      //     field_goals_made: 2,
      //     field_goals_attempted: 2,
      //     field_goals_rate: 100,
      //     stringAddition_2_Point_ma: '0/0',
      //     averageValue_2_Point_rate: 0,
      //     two_point_shots_made: 0,
      //     two_point_shots_attempted: 0,
      //     two_point_shots_rate: 0,
      //     stringAddition_3_Point_ma: '2/2',
      //     three_point_shots_made: 2,
      //     three_point_shots_attempted: 2,
      //     three_point_shots_rate: 100,
      //     stringAddition_Free_Throws_ma: '1/1',
      //     free_throws_made: 1,
      //     free_throws_attempted: 1,
      //     free_throws_rate: 100,
      //   },
      //   {
      //     pts: 7,
      //     tot: 0,
      //     or: 0,
      //     dr: 0,
      //     as: 0,
      //     to: 0,
      //     st: 1,
      //     bs: 0,
      //     pf: 0,
      //     fd: 0,
      //     organisation_code: 'KUW',
      //     player_id: 'BKBMS000149',
      //     bib_number: '7',
      //     player_name: 'XU Kunhao',
      //     stringAddition_Field_Goals_ma: '2/2',
      //     averageValue_Field_Goals_rate: 100,
      //     field_goals_made: 2,
      //     field_goals_attempted: 2,
      //     field_goals_rate: 100,
      //     stringAddition_2_Point_ma: '1/1',
      //     averageValue_2_Point_rate: 100,
      //     two_point_shots_made: 1,
      //     two_point_shots_attempted: 1,
      //     two_point_shots_rate: 100,
      //     stringAddition_3_Point_ma: '1/1',
      //     three_point_shots_made: 1,
      //     three_point_shots_attempted: 1,
      //     three_point_shots_rate: 100,
      //     stringAddition_Free_Throws_ma: '2/2',
      //     free_throws_made: 2,
      //     free_throws_attempted: 2,
      //     free_throws_rate: 100,
      //   },
      //   {
      //     pts: 7,
      //     tot: 0,
      //     or: 0,
      //     dr: 0,
      //     as: 0,
      //     to: 0,
      //     st: 1,
      //     bs: 0,
      //     pf: 0,
      //     fd: 0,
      //     organisation_code: 'KUW',
      //     player_id: 'BKBMS000147',
      //     bib_number: '5',
      //     player_name: 'SONG Yuyan',
      //     stringAddition_Field_Goals_ma: '2/2',
      //     averageValue_Field_Goals_rate: 100,
      //     field_goals_made: 2,
      //     field_goals_attempted: 2,
      //     field_goals_rate: 100,
      //     stringAddition_2_Point_ma: '1/1',
      //     averageValue_2_Point_rate: 100,
      //     two_point_shots_made: 1,
      //     two_point_shots_attempted: 1,
      //     two_point_shots_rate: 100,
      //     stringAddition_3_Point_ma: '1/1',
      //     averageValue_3_Point_rate: 100,
      //     three_point_shots_made: 1,
      //     three_point_shots_attempted: 1,
      //     three_point_shots_rate: 100,
      //     free_throws_made: 2,
      //     free_throws_attempted: 2,
      //     free_throws_rate: 100,
      //   },
      // ],
    }
  },
  methods: {
    goDetail(routerName, item, id) {
      console.debug('goDetail:', routerName, item, this.isBroadCastList)
      if (this.isBroadCastList) return
      if (
        item.player_name === '总计' &&
        this.tableMode === 'eventComp_mode_5_BKB'
      ) {
        return
      }
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = ''
          return
        }
        if (index === 1) {
          sums[index] = '总计'
          return
        }
        // console.debug(column.property, data)
        if (column.property.indexOf('stringAddition') > -1) {
          const values = data.map((item) => item[column.property])
          console.debug(column.property, data, values)
          if (values.every((value) => value.indexOf('/') > -1)) {
            let num = 0,
              den = 0
            values.forEach((item) => {
              let arr = item.split('/')
              num += arr[0] - 0
              den += arr[1] - 0
            })
            sums[index] = `${num}/${den}`
          } else {
            sums[index] = 'N/A'
          }
        } else if (column.property.indexOf('averageValue') === 0) {
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            let totalVal = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index] = Math.round((totalVal / values.length) * 10) / 10
          } else {
            sums[index] = 'N/A'
          }
        } else {
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            sums[index]
          } else {
            sums[index] = 'N/A'
          }
        }
      })

      return sums
    },
    cellStyle(bodyCell) {
      // console.debug(bodyCell)
      if (this.columnColorPropArr.includes(bodyCell.column.property)) {
        return {
          backgroundColor: 'var(--mixtmt_greyColor8)',
        }
      } else if (this.textAlignleftPropArr.includes(bodyCell.column.property)) {
        return {
          textAlign: 'left',
        }
      } else {
        return ''
      }
    },
    headerCellStyle(headCell) {
      if (this.textAlignleftPropArr.includes(headCell.column.property)) {
        return {
          textAlign: 'left',
        }
      } else {
        return ''
      }
    },
    rowClassName(row, rowIndex) {
      if (row.row.isRowMark && row.row.isRowMark === 'showPlayer') {
        return 'rowPlayerItem'
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.compreSportsMeet_mergeHeadCel_table {
  .cell {
    .teamLogo-teamName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 0 0.694vw;
      height: 2.788vw;
      .teamLogo {
        width: 2.916vw;
        height: 1.944vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: calc(100% - 2.083vw);
        padding-left: 1.04vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .playerName-playerLogo-playerGender-teamLogo-teamName {
      height: 4.16vw;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerLogo {
        position: relative;
        width: 4.16vw;
        height: 4.16vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          /* background-image: var(--mixtmt_gender_male_icon); */
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerOther {
        width: calc(100% - 4.16vw);
        padding: 0 0.694vw;
        height: 4.16vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        .teamInfor {
          width: 100%;
          height: 2.25vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .teamLogo {
            width: 2.5vw;
            height: 1.66vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-left: 0.694vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor2);
          }
        }
        .playerName {
          width: auto;
          max-width: 100%;
          font-size: 1.11vw;
          height: 1.38vw;
          line-height: 1.38vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .group_rowCeilClass {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
    }
    .rowCeilClass {
      width: 100%;
      padding: 0.347vw 0;
      height: 1.66vw;
      line-height: 1.66vw;
    }
    .color {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .colorArea {
        width: 2.43vw;
        height: 1.38vw;
        border-width: 1px;
        border-style: solid;
      }
    }

    .single-player-name {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerName {
        width: auto;
        max-width: 100%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  /* &.eventComp_mode_17_SHO,
  &.eventComp_mode_17_GAR,
  &.eventComp_mode_17_TKW {
    .cell {
      .playerName-playerLogo-playerGender-teamLogo-teamName {
        height: 4.16vw;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  } */
}
.mixtmt_pc {
  .compreSportsMeet_mergeHeadCel_table:not(.onlyDisplay) {
    .cell {
      .playerName-playerLogo-playerGender-teamLogo-teamName,
      .playerName-playerLogo-playerGender-teamLogo-teamName-FEN {
        .playerOther {
          .playerName {
            &:hover {
              cursor: pointer;
              color: var(--mixtmt_subColor1_1);
              text-decoration: underline;
            }
          }
        }
      }
      .operateArr_btn {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_subColor1_1);
          color: var(--mixtmt_whiteColor);
        }
      }
      .teamLogo-teamName {
        .teamName {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
      .teamLogo-teamName-playerListString,
      .teamLogo-playerListString {
        .playerList {
          .player_item {
            .playerItem_name {
              &:hover {
                cursor: pointer;
                color: var(--mixtmt_subColor1_1);
                text-decoration: underline;
              }
            }
          }
        }
      }
      .playerName-playerLogo,
      .single-player-name {
        .playerName {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
    }
    &.eventComp_mode_5_BKB {
      .el-table__body tr.el-table__row {
        &:last-child {
          .columnTextLeftClass {
            .cell {
              .single-player-name {
                .playerName {
                  &:hover {
                    color: var(--mixtmt_greyColor2);
                    text-decoration: none;
                    cursor: default;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.compreSportsMeet_mergeHeadCel_table {
  &.eventComp_mode_17_SHO,
  &.eventComp_mode_17_GAR,
  &.eventComp_mode_17_TKW {
    .el-table {
      .cell {
        .teamLogo-teamName {
          height: 2.788vw;
          .teamLogo {
            width: 2.916vw;
            height: 1.944vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
          }
        }
      }
    }
  }

  &.eventComp_mode_21_SHO {
    .el-table {
      .cell {
        .teamLogo-teamName {
          height: 4.16vw;
          .teamLogo {
            width: 2.916vw;
            height: 1.944vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
          }
          .teamName {
            font-size: 0.972vw;
          }
        }
      }
      .rowPlayerItem {
        background-color: var(--mixtmt_greyColor8);
      }
    }
  }

  .el-table {
    font-size: 0;
    color: var(--mixtmt_greyColor2);
    .mixtmt_table_header {
      th.el-table__cell {
        padding: 0.972vw 0;
        background-color: var(--mixtmt_table_headerBg);
        color: var(--mixtmt_table_headerColor);
        height: 3.332vw;
        & > .cell {
          padding: 0;
          font-size: 0.974vw;
          line-height: 1.388vw;
          text-align: center;
        }
        &.columnNumLogoNameClass {
          & > .cell {
            padding-left: 3.472vw;
            text-align: left;
          }
        }
        &.columnTitleLeft {
          & > .cell {
            padding-left: 0.694vw;
            text-align: left;
          }
        }
        &.columnPlayerGroupClass {
          & > .cell {
            padding-left: 4.16vw;
            text-align: left;
          }
        }
        &.columnTeamLogoTeamNameClass {
          & > .cell {
            padding-left: 4.16vw;
            text-align: left;
          }
        }
        &.columnTextLeftClass {
          & > .cell {
            text-align: left;
            padding-left: 0.694vw;
          }
        }
      }
    }
    .el-table__cell {
      border-bottom: 1px solid var(--mixtmt_greyColor12);
    }
  }
  .el-table {
    .el-table__body {
      .columnTeamLogoTeamNameClass {
        & > .cell > span:not(.teamLogo-teamName) {
          padding-left: 1.388vw;
          text-align: left;
        }
      }
    }
  }
  .el-table .cell {
    line-height: 1.66vw;
  }
  .el-table--border .el-table__cell,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 0;
  }
  .el-table--border::after,
  .el-table--group::after {
    width: 0;
  }
  .el-table--border,
  .el-table--group {
    border: 0;
  }
  .el-table td.el-table__cell,
  .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--mixtmt_greyColor12);
  }
  .el-table th.el-table__cell > .cell {
    padding: 0;
  }

  .el-table__expand-icon > .el-icon {
    margin: 0;
    transform: translate(-50%, -50%);
  }

  .el-table__cell {
    padding: 0.347vw 0;
    text-align: center;
  }
  .el-table {
    .cell {
      padding: 0;
      font-size: 0.972vw;
      /* font-weight: bold; */
    }
    .mixtmt_table_header {
      .el-table__cell {
        padding: 0;
        background-color: var(--mixtmt_table_headerBg);
        color: var(--mixtmt_table_headerColor);
      }
    }
  }
  .el-table--border th.el-table__cell,
  .el-table__fixed-right-patch {
    border-bottom: 0;
  }
  .el-table--border .el-table__cell:first-child .cell {
    padding-left: 0;
  }
  .el-table__footer-wrapper tbody td.el-table__cell,
  .el-table__header-wrapper tbody td.el-table__cell {
    /* background-color: var(--mixtmt_greyColor8); */
    background-color: var(--mixtmt_whiteColor);
    color: var(--mixtmt_greyColor2);
    font-size: 0.833vw;
    &.columnHightBgClass {
      background-color: var(--mixtmt_greyColor8);
    }
    &.columnTextLeftClass {
      .cell {
        text-align: left;
      }
    }
  }
}

#app.mixtmt_pc .compreSportsMeet_mergeHeadCel_table {
  &.notJumpDetailPageClass {
    *:not(.publishBtn) {
      cursor: default !important;
    }
  }
}
</style>
